const l = {
  name: "Banjo",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M36.9,0c-0.8,0-1.6,0.3-2.2,0.9l-1.2,1.2l-1.8-1.8l-1.4,1.4l1.8,1.8l-1.6,1.6l-1.8-1.8l-1.4,1.4l1.8,1.8
			L16.3,19.3C14.7,18.5,12.9,18,11,18C4.9,18,0,22.9,0,29s4.9,11,11,11c6.1,0,11-4.9,11-11c0-1.9-0.5-3.7-1.3-5.3l12.8-12.8l1.8,1.8
			l1.4-1.4l-1.8-1.8l1.6-1.6l1.8,1.8l1.4-1.4l-1.8-1.8l1.2-1.2C39.7,4.7,40,3.9,40,3.1C40,1.4,38.6,0,36.9,0z M33.5,8.1l-1.6-1.6
			l1.6-1.6l1.6,1.6L33.5,8.1z M30.5,7.9l1.6,1.6L19.5,22.1c-0.5-0.6-1-1.1-1.6-1.6L30.5,7.9z M34.9,3.5l1.2-1.2
			C36.3,2.1,36.6,2,36.9,2C37.5,2,38,2.5,38,3.1c0,0.3-0.1,0.6-0.3,0.8l-1.2,1.2L34.9,3.5z M12.6,29L11,30.6L9.4,29l1.6-1.6L12.6,29
			z M15.4,29l3.8-3.8c0.5,1.1,0.8,2.4,0.8,3.8c0,5-4,9-9,9c-5,0-9-4-9-9s4-9,9-9c1.3,0,2.6,0.3,3.8,0.8L11,24.6l-1.3-1.3l-1.4,1.4
			L9.6,26L8,27.6l-1.3-1.3l-1.4,1.4L6.6,29l-1.3,1.3l1.4,1.4L8,30.4L9.6,32l-1.3,1.3l1.4,1.4l1.3-1.3l1.3,1.3l1.4-1.4L12.4,32
			l1.6-1.6l1.3,1.3l1.4-1.4L15.4,29z M14,27.6L12.4,26l4.1-4.1c0.6,0.5,1.1,1,1.6,1.6L14,27.6z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Banjo
};
